export default function NewsletterList({ items }) {
  if (!items.length) {
    return <p className="empty">No newsletters created yet.</p>;
  }

  return (
    <div className="card">
      <h3>Scheduled Newsletters</h3>

      <table>
        <thead>
          <tr>
            <th>Title</th>
            <th>Schedule Date</th>
            <th>Status</th>
          </tr>
        </thead>

        <tbody>
          {items.map((n) => (
            <tr key={n._id}>
              <td>{n.title}</td>
              <td>{n.scheduleDate}</td>
              <td className="status">Scheduled</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
